<template>
  <div class="fs-replacement-notification" v-if="trap_replaced_on">
    <div class="fs-replacement-notification__status">
      {{ $t('status', { date: replaced, days: daysRemaining }) }}
    </div>
    <div class="fs-replacement-notification__warning" v-if="daysExceeded">
      {{ $t('warning', { days: daysExceeded }) }}
    </div>
  </div>
</template>

<i18n lang="yaml">
ja:
  status: 前回捕虫紙交換日:{date}  交換まで{days}日
  warning: 前回捕虫紙交換日から{days}日を過ぎています、交換してください。

en:
  status: Trap replaced on {date} ({days} days until next replacement)
  warning: Trap was supposed to be replaced {days} days ago. Please replace the trap.
</i18n>

<script>
import { differenceInDays, parse } from 'date-fns';
import DateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'ReplaceNotificationAlert',
  mixins: [DateTimeFormatting],
  props: {
    trap_replaced_on: String, // YYYY-MM-DD
    trap_effective_days: Number,
  },
  computed: {
    daysExceeded() {
      const result = this.interval - this.daysSinceReplacement;
      if (result < 0) {
        return Math.abs(result);
      }
      return null;
    },
    daysRemaining() {
      const result = this.interval - this.daysSinceReplacement;
      if (result > 0) {
        return result;
      }
      return 0;
    },
    replaced() {
      return this.formatDate(this.trap_replaced_on);
    },
    daysSinceReplacement() {
      const replaced = parse(this.trap_replaced_on, 'yyyy-MM-dd', new Date());
      return differenceInDays(new Date(), replaced);
    },
    interval() {
      if (this.trap_effective_days != null) {
        return this.trap_effective_days;
      }
      return 30; // as default
    },
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.fs-replacement-notification
  text-align: left
  margin: 0.5rem 0 0.5rem 8px

  &__status
    font-size: 14px
    line-height: 1.4

  &__warning
    color: #ef8200
    font-size: 14px
    font-weight: bold
    line-height: 1.4
    margin-top: 0.25rem
</style>
